<template>
    <nav
        class="k-breadcrumbs"
        :aria-label="label"
    >
        <ol class="k-breadcrumbs__list">
            <li
                v-for="(item, index) in items"
                :key="`${item.label}-${index}`"
                class="k-breadcrumbs__item"
            >
                <component
                    :is="linkAs"
                    v-if="index < items.length - 1 && item.href"
                    class="k-breadcrumbs__link"
                    v-bind="linkAttributes(item.href)"
                >
                    {{ item.label }}
                </component>
                <span
                    v-else
                    class="k-breadcrumbs__current"
                    aria-current="page"
                >
                    {{ item.label }}
                </span>

                <span
                    v-if="index < items.length - 1"
                    class="k-breadcrumbs__separator"
                    aria-hidden="true"
                >
                    <svg
                        viewBox="0 0 16 16"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="m6 3 5 5-5 5" />
                    </svg>
                </span>
            </li>
        </ol>
    </nav>
</template>

<script setup lang="ts">
import type { KBreadcrumbsProps } from './types'

const {
    items,
    label = 'Breadcrumb',
    linkAs = 'a',
} = defineProps<KBreadcrumbsProps>()

function linkAttributes(href: string) {
    return linkAs === 'a' ? { href } : { to: href }
}
</script>

<style lang="scss">
@use 'k-breadcrumbs';
</style>
